import config from '../config'
import { axios, configDefaultRequest } from '../utils/request'

const fetchRequest = axios.create({
  baseURL: config.backendBaseUrl,
  headers: { Authorization: `Bearer ${config.backendAuthorization}` }
})

const uploadRequest = axios.create({
  baseURL: config.uploadBaseUrl,
  headers: { Authorization: `Bearer ${config.uploadAuthorization}` }
})

configDefaultRequest(fetchRequest)
configDefaultRequest(uploadRequest)

export function FETCH_FROM_API(action) {
  return fetchRequest.get(action.path)
}
